import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { SelectMultipleDesktop } from './SelectMultipleDesktop';
import { SelectMultipleMobile } from './SelectMultipleMobile';

/**
 * @param {object} props - Props.
 * @param {string} props.label - Label.
 * @param {any[]} props.items - Items.
 * @param {Function} [props.itemToString] - Item to string.
 * @param {Function} [props.getInitialSelectedItems] - Selected items.
 * @param {Function} props.onSelectedItemsChange - On change callback.
 * @param {Function} props.addOnResetCallback - On reset callback.
 * @param {Function} props.getItemText - Given an item, get the text that
 *    represents the item.
 * @param {Function} props.getItemLabel - Given an item, get the label for the
 *    item. It can be text or some JSX.
 * @returns {JSX.Element} Component.
 */
export const SelectMultiple = (props) => {
    const [selectedItems, setSelectedItems] = useState([]);

    /**
     * @param {any} item - Item.
     * @returns {boolean} True if item is in selected items, otherwise false.
     */
    const isItemInSelectedItems = (item) =>
        selectedItems.some((i) =>
            // @ts-ignore
            _.isEqual(i, item)
        );

    const toggleSelectedItem = (selectedItem) => {
        if (isItemInSelectedItems(selectedItem)) {
            setSelectedItems((curr) =>
                curr.filter(
                    (item) =>
                        // @ts-ignore
                        !_.isEqual(item, selectedItem)
                )
            );
            return;
        }

        setSelectedItems((curr) => [...curr, selectedItem]);
    };

    useEffect(() => {
        setSelectedItems(
            props.getInitialSelectedItems ? props.getInitialSelectedItems() : []
        );
    }, [props.items]);

    useEffect(() => {
        props.onSelectedItemsChange(selectedItems);
    }, [selectedItems]);

    useEffect(() => {
        props.addOnResetCallback(() => setSelectedItems([]));
    }, []);

    const selectMultipleProps = {
        items: props.items,
        label: props.label,
        isItemInSelectedItems,
        toggleSelectedItem,
        selectedItems,
        getItemText: props.getItemText,
        getItemLabel: props.getItemLabel,
        clearSelectedItems: () => setSelectedItems([])
    };

    return (
        <>
            <div className="u-hide-until-desktop w-100">
                <SelectMultipleDesktop {...selectMultipleProps} />
            </div>
            <div className="u-hide-from-desktop w-100">
                <SelectMultipleMobile {...selectMultipleProps} />
            </div>
        </>
    );
};

SelectMultiple.propTypes = {
    label: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.any),
    itemToString: PropTypes.func,
    getInitialSelectedItems: PropTypes.func,
    onSelectedItemsChange: PropTypes.func.isRequired,
    addOnResetCallback: PropTypes.func.isRequired,
    getItemText: PropTypes.func.isRequired,
    getItemLabel: PropTypes.func.isRequired
};
